import {
    joinErrors,
    useTranslateErrors,
} from '@composables/useTranslateErrors';
import type { ApiErrors, KeyOfErrors } from '@repository/types';

export const useFetchErrors = () => {
    const toast = useMyToast();
    const { translateErrorsObject, joinTranslatedErrorsObject } =
        useTranslateErrors();

    const showErrors = (errors: ApiErrors<KeyOfErrors>) => {
        const translated = translateErrorsObject(errors);
        const joined = joinTranslatedErrorsObject(translated);
        const errorsToShow = joinErrors(Object.values(joined));
        toast.error(errorsToShow);
    };

    return {
        showErrors,
    };
};
